<template lang="pug">
  div(style="padding: 10px 0")
    h3 Control Panel 
      p
        small Current Developer: {{ $store.state.user.user.username }}
    hr
    h5 cabinet layout in database 
      button(@click="initLocalSystem") Refresh
    div.layout-region
      h5 {{ systemName }}
      div.system-layout(v-for="sys, sys_num in systemsCopy")
        span {{ sys.relative_index }} (SN:{{sys.serial}})
        div.net-layout(v-for="net, net_num in sys.net_set")
          div.net-pos(:class="{ 'background-green': net.LED_color === 'green', 'bling': net.LED_status, 'status-badge': true }")
            span {{ net.position }}
          div.net-content
            span#netID Drawer {{net.row_id}} (id:{{net.id}})
            button(@click="openAllDevices(net)") OpenAll
            button.float-right(@click="toggleNet(sys_num, net_num)") Expand / Close
            div.device-wrap(v-show="net.toggled")
              div.device-layout(v-for="device in net.device_set" 
                :class="{ 'background-green': device.LED_color === 'green', 'bling': device.LED_status }"
                )
                p {{ device.pos_row }} - {{ device.relative_col }} (w={{device.width}},r={{device.pos_col}},id={{device.id}})
                div
                  button.btn.btn-primary.btn-sm(@click="openDeviceById(device.id)") 
                    span(v-if="device.pos_row === 0") OpenDrawer
                    span(v-else) Open
                  button.btn.btn-danger.btn-sm(@click="delDevice(device.id)") Remove
    hr
    h5 Detected Layout 
      button(@click="getDetectedDevices") Refresh
    div.layout-region(v-if="detectedDevices.length !== 0")
      div.net-layout
        div.device-wrap
          div.device-layout(v-for="device in detectedDevices")
            p.text-center System: {{device.net.system}}
            p.text-center Net:{{ device.net.row_id }} 
            p.text-center {{ device.pos_row }} - {{ device.relative_col }} - width: {{device.width}}
            //- button.btn.btn-primary.float-right(@click="openDeviceById(device.id)") open
            div
              button.btn.btn-info.btn-sm(@click="setupDetectedDevice(device.id)") Add
              button.btn.btn-danger.btn-sm(@click="removeDetectedDevice(device.id)") Remove
    p(v-else) 
      small No newly detected device in database.
    
    hr
    h5 Testing tool
    form(v-on:submit.prevent="openTargetDrawerAndDevices")
      span 藥櫃編號 
      input(placeholder="cabinet index" name="cabInd" type="number")
      span 抽屜編號
      input(placeholder="drawer index" name="drawerInd" type="number")
      span &nbsp
      button(type="submit") 開啟整層抽屜及藥盒
      small &nbsp (可按enter進行測試)
      p last tested cabinet index: {{ previousTestCabInd }}, drawer index: {{ previousTestDrawerInd }}
      p 目前測試次數: {{ testTimes }}
    hr
    //- button reset database
    h5 Other command
    button(@click="sendLayoutCommand") Rescan layout
    button(@click="removeAllDevices") Remove All Devices
    button(@click="removeAllDrugStorages") Remove All DrugStorages
    button(@click="createRandomDrugStorages") Create Random DrugStorages
    button(@click="removeAllEvent") Remove all Events

    
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import server, { TaskWebSocketServer } from '@/config';

export default {
  name: 'DevPanel',
  data() {
    return {
      showNetIndex: [],
      previousDevices: {},
      detectedDevices: [],
      systemsCopy: [],
      previousTestCabInd: 0,
      previousTestDrawerInd: 0,
      testTimes: 0,
      systemName: '',
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    systemLayoutChecked() {
      return this.$store.state.systemLayoutChecked;
    },
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
  },
  created() {
    this.getDetectedDevices();
    this.initLocalSystem();
    this.systemName = this.systemsCopy[0].name;
  },
  mounted() {
  },
  methods: {
    openTargetDrawerAndDevices(event) {
      const cabInd = parseInt(event.target.elements.cabInd.value, 10);
      const drawerInd = parseInt(event.target.elements.drawerInd.value, 10);
      console.log(cabInd, drawerInd);
      // reset the test time counter if cab or drawer changed
      if (cabInd !== this.previousTestCabInd || drawerInd !== this.previousTestDrawerInd) {
        this.testTimes = 0;
        this.previousTestCabInd = cabInd;
        this.previousTestDrawerInd = drawerInd;
        localStorage.setItem('previous', `${this.previousTestCabInd};${this.previousTestDrawerInd}`);
      }

      this.testTimes += 1;
      localStorage.setItem('testTimes', this.testTimes);

      this.openAllDevices(this.systems[cabInd - 1].net_set[drawerInd - 1]);
    },
    initLocalSystem() {
      this.systemsCopy = Object.values(this.$store.state.device.systems);
      this.systemsCopy.forEach((sys) => {
        sys.net_set.forEach((net) => {
          sys.serial = net.system_serial;
          net.toggled = false;
          net.position = 0;
          net.LED_color = null;
          net.LED_status = null;
          net.device_set.forEach((device) => {
            device.LED_color = null;
            device.LED_status = null;
          });
        });
      });
    },
    toggleNet(sysInd, netInd) {
      console.log(this.systemsCopy[sysInd].net_set[netInd].toggled);
      this.systemsCopy[sysInd].net_set[netInd].toggled = !this.systemsCopy[sysInd].net_set[netInd].toggled;
      this.$forceUpdate();
    },
    resetSystem() {
      const system = this.systems;
      if (Object.keys(this.previousDevices).length !== 0) {
        const key = Object.keys(this.previousDevices)[0];
        const systemId = key.split('-')[0];
        const drawerId = key.split('-')[1];
        system[systemId].net_set[drawerId - 1].LED_color = null;
        system[systemId].net_set[drawerId - 1].LED_status = null;
        this.systems = Object.assign([], this.systems, system);
      }
    },
    openAllDevices(net) {
      const deviceSet = net.device_set;
      _.orderBy(deviceSet, ['pos_row', 'pos_col']).forEach((item) => {
        console.log(item.pos_row, item.pos_col);
      });
      let times = 0;
      const intervalTime = 0;
      _.orderBy(deviceSet, ['pos_row', 'pos_col']).forEach((device) => {
        setTimeout(() => {
          this.openDeviceById(device.id);
        }, times * intervalTime);
        times += 1;
      });
    },
    openDeviceById(deviceId) {
      this.$store.dispatch('openDevice', deviceId);
    },
    getDetectedDevices() {
      return this.instance.get('/api/detected-device/')
      .then((res) => {
        this.detectedDevices = [];
        this.detectedDevices = Object.assign([], this.detectedDevices, res.data);
      });
    },
    sendLayoutCommand() {
      return this.instance.post('/adc-control/send-layout-message/');
    },
    delDevice(deviceId) {
      const ans = confirm('delete this device? all drugStorage in this device will be deleted simultaneously.');
      if (ans) {
        this.instance.delete(`/api/device/${deviceId}/`)
        .then(() => {
          // alert('已刪除');
          this.$store.dispatch('getSystemInfo')
          .then(() => {
            this.initLocalSystem();
          });
        });
      }
    },
    setupDetectedDevice(deviceId) {
      return axios.post(`${server}/adc-control/setup-detected-device/`, { id: deviceId })
      .then(() => {
        // alert('完成新增');
        this.$store.dispatch('getSystemInfo')
        .then(() => {
          this.initLocalSystem();
        })
        .then(() => {
          this.getDetectedDevices();
        });
      });
    },
    removeDetectedDevice(deviceId) {
      return axios.delete(`${server}/api/detected-device/${deviceId}/`)
      .then(() => {
        // alert('完成刪除');
        this.$store.dispatch('getSystemInfo')
        .then(() => {
          this.initLocalSystem();
        })
        .then(() => {
          this.getDetectedDevices();
        });
      });
    },
    removeAllDevices() {
      this.instance.get('/adc-control/remove-all-devices/');
    },
    removeAllDrugStorages() {
      this.instance.get('/remove-all-drug-storages/');
    },
    createRandomDrugStorages() {
      this.instance.post('/create-random-drug-storages/', { systemId: this.$store.state.device.systemId });
    },
    removeAllEvent() {
      this.instance.get('/remove-all-events/');
    },
    updateSystemStatus(errorDevices) {
      const system = this.systemsCopy;
      const nowDevices = {};
      if (errorDevices.length !== 0) {
        errorDevices.forEach((d) => {
          if (d.type === 'drawer') {
            nowDevices[`${d.system}-${d.drawerId}`] = 'drawer';
            // this.$set(system[d.system].net_set[d.drawerId - 1], 'LED_color', d.LED_color);
            // this.$set(system[d.system].net_set[d.drawerId - 1], 'LED_status', d.LED_status);
            system[d.system].net_set[d.drawerId - 1].LED_color = d.LED_color;
            system[d.system].net_set[d.drawerId - 1].LED_status = d.LED_status;
          }
          if (d.type === 'box') {
            nowDevices[`${d.system}-${d.drawerId}-${d.boxId}`] = 'box';
            const device = system[d.system].net_set[d.drawerId - 1].device_set[d.boxId];
            // this.$set(this.system[d.system].net_set[d.drawerId - 1].device_set[d.boxId - 1], 'LED_color', d.LED_color);
            // this.$set(device, 'LED_status', d.LED_status);
            // this.$set(device, 'LED_color', d.LED_color);
            device.LED_status = d.LED_status;
            device.LED_color = d.LED_color;
          }
        });
        // compare which device is closed
        Object.keys(nowDevices).forEach((key) => {
          if (key in this.previousDevices) {
            delete this.previousDevices[key];
          }
        });

        Object.entries(this.previousDevices).forEach((item) => {
          const key = item[0];
          const type = item[1];
          const keySplit = key.split('-');
          const systemId = keySplit[0];
          const drawerId = keySplit[1];

          if (type === 'drawer') {
            system[systemId].net_set[drawerId - 1].LED_color = null;
            system[systemId].net_set[drawerId - 1].LED_status = null;
          }
          if (type === 'box') {
            const boxId = keySplit[2];
            system[systemId].net_set[drawerId - 1].device_set[boxId].LED_color = null;
            system[systemId].net_set[drawerId - 1].device_set[boxId].LED_status = null;
          }
        });
        this.previousDevices = nowDevices;
        this.systems = Object.assign([], this.systems, system);
        this.$forceUpdate();
      }
    },
  },
  watch: {
    systemLayoutChecked(val) {
      console.log(val);
      this.initLocalSystem();
    },
    errorDevices(val) {
      this.updateSystemStatus(val);
    },
  },
};
</script>

<style lang="sass" scoped>
$box-width: 80px

.system-layout
  #netID
    margin: 0px
.net-layout
  border: 1px solid
  display: flex
  .net-pos
    width: 20px
  .net-content
    width: calc(100% - 20px)

.status-badge
  width: 20px
  border: 1px solid rgba(0,0,0,0.3)
  display: flex
  justify-content: center
  align-items: center



.device-wrap
  width: 100%
  .device-layout
    border: 1px solid
    display: flex;
    justify-content: space-between;
    background-color: white
    p
      margin: 0px

.background-green
  background-color: green;

.background-red
  background-color: red;

.bling
  animation-duration: 1s;
  animation-name: backgroundChanged;
  animation-iteration-count: infinite;
  animation-direction: alternate;

@keyframes backgroundChanged
  0%
    background-color: transparent
  100%
    background-color: green;



.width-0
  width: 100%

.width-1
  width: $box-width

.width-2
  width: $box-width * 2

.width-3
  width: $box-width * 3

.width-4
  width: $box-width * 4

.width-5
  width: $box-width * 5

.width-6
  width: $box-width * 6


</style>



// WEBPACK FOOTER //
// DevPanel.vue?4bea78fe